/* eslint import/first: 0 */
/* global document, window */
import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import initialize from './redux/index';
import App from './App';
import './styles';

const { store, history } = initialize(
    null,
    { options: [window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()] }, // eslint-disable-line
);

const Main = () => <Provider store={store}>
    <ConnectedRouter
        history={history}
    >
        <App />
    </ConnectedRouter>
</Provider>;

ReactDOM.render(
    <Main />,
    document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/client/index.js